import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import Comments from './Comments';

const CommentModal = ({ show, handleClose, urlHeading }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      contentClassName="bg-dark text-light border-secondary"
    >
      <Modal.Header closeButton closeVariant="white" className="border-secondary">
        <Modal.Title>💬 Comments</Modal.Title>
      </Modal.Header>

      <Modal.Body className="border-secondary">
        {urlHeading ? (
          <Comments urlHeading={urlHeading} />
        ) : (
          <p className="text-muted">No blog selected</p>
        )}
      </Modal.Body>

      <Modal.Footer className="border-secondary">
        <Button variant="outline-light" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CommentModal;